export default __webpack_public_path__ + "static/media/25092704.83395554.jpg";